import _ from 'lodash';

import {updateManualCalculateRows} from "../../../actions/sqftManualCalculationFunctions";
import {MANUAL_CALCULATION_ROW_TYPES} from "../constants";
import store from "../../../store";
import {DEFAULT_MANUAL_CALC_ROW} from "../../../reducers/sqftManualCalculationReducer";
import {getEdgeFeatures} from "./shapeHelper";
import workspace from "../components/canvas/core/workspace";

export const manualCalculateImport = (data) => {
  console.log("import manualcalc data", data);
  let manualCalculationRows = prepareData(data);
  store.dispatch(updateManualCalculateRows(manualCalculationRows));
}

const prepareData = (data) => {
  return {
    [MANUAL_CALCULATION_ROW_TYPES.countertopRows] : prepareCountertopRows(data.countertops),
    [MANUAL_CALCULATION_ROW_TYPES.backsplashRows] : prepareBacksplashRows(data.backsplashes),
    [MANUAL_CALCULATION_ROW_TYPES.edgeRows] : prepareEdgeRows(data.edges),
  }
}

const prepareCountertopRows = (dataCountertops) => {
  let preparedData = [];
  dataCountertops.forEach((dataCountertop, index) => {
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataCountertop.id ? dataCountertop.id : index;
    row.length = dataCountertop.inputLength;
    row.width = dataCountertop.inputWidth;
    preparedData.push(row);
  })

  return preparedData;
}

const prepareBacksplashRows = (dataBacksplashes) => {
  let preparedData = [];
  dataBacksplashes.forEach((dataBacksplash, index) => {
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataBacksplash.id ? dataBacksplash.id : index;
    row.length = dataBacksplash.inputLength;
    row.height = dataBacksplash.inputHeight;
    preparedData.push(row);
  })

  return preparedData;
}

const prepareEdgeRows = (dataEdges) => {
  let preparedData = [];
  dataEdges.forEach((dataEdge, index) => {
    const navItems = getEdgeFeatures();
    const navItem = navItems.find(edge => edge.part.dbFeature.id === dataEdge.featureId);
    let row = _.clone(DEFAULT_MANUAL_CALC_ROW);
    row.id = dataEdge.id ? dataEdge.id : index;
    row.length = dataEdge.inputLength;
    row.height = dataEdge.inputHeight;
    row.selectedFeature = navItem.part;
    preparedData.push(row);
  })

  return preparedData;
}

export const clearManualCalcData = () => {
  for (const manualCalculationRowType in MANUAL_CALCULATION_ROW_TYPES) {
    store.dispatch(updateManualCalculateRows({[manualCalculationRowType]: []}));
  }
}

export const getGroupedShapesByColor = () => {
  const shapes = workspace.getShapes();
  return shapes.flatMap(shp => {
    if (shp.getColorSet) {
      const colorSet = shp.getColorSet();
      return colorSet ? colorSet : [];
    }
    return [];
  })
}

export const getFeatureGlb = (feature) => {
  const threeDSrc = feature.dbFeature.thirdPartyAR3DUrls.map(src => {
    src = src.replace("s3.amazonaws.com/qc-lixil-3dfiles", "dv84u4f1bblk2.cloudfront.net");
    return src
  })
  return threeDSrc.find(url => url.includes(".glb"));
}
